import { ListItemControlItems, StaticControlItem } from '../types/types';
import { isControlItemValue } from './isControlItemValue';
import { parseJsonArrayValue } from './parseJsonArrayValue';

// Maps the JSON array delivered in the GET/DEFAULT response property named by listItem to { value, label } options
export const resolveListItemOptions = (
  controlItems: ListItemControlItems,
  rawList: unknown
): StaticControlItem[] => {
  const { valueItem = 'value', labelItem = 'label' } = controlItems;

  return parseJsonArrayValue(rawList).reduce<StaticControlItem[]>(
    (acc, entry) => {
      if (isControlItemValue(entry)) {
        acc.push({ value: entry, label: String(entry) });
        return acc;
      }

      if (typeof entry !== 'object' || entry === null) {
        return acc;
      }

      const record = entry as Record<string, unknown>;
      const value = record[valueItem];
      if (!isControlItemValue(value)) {
        return acc;
      }

      acc.push({ value, label: String(record[labelItem] ?? value) });
      return acc;
    },
    []
  );
};
